<template>
  <div v-if="enabled" class="button-width-helper">
    <div v-show="completed && canDelete" class="agenda-footer__button">

      <button @click="$emit('updateScheduler')" class="agenda-schedule-button">
        <img src="/images/attendee-dashboard/icons/check-blue.png" width="25" alt="On My Schedule"> On My Schedule
      </button>
    </div>
    <div v-show="!completed" class="agenda-footer__button">

      <button @click="$emit('updateScheduler')" class="agenda-schedule-button">
        <img src="/images/attendee-dashboard/icons/plus.png" width="25" alt="Add to My Schedule"> Add to My Schedule
      </button>
    </div>
  </div>
</template>


<style lang="scss">
.agenda-schedule-button {
  height: 30px;
  //padding: 0 var(--attendee-gap-md);
  display: flex;
  gap: 10px;
  align-items: center;
  appearance: none;
  border: none;
  outline: none;
  box-shadow: none;

  color: black;
  font-size: 14px;
  background-color: white;

  img {
    width: 25px;
    height: auto;
  }
}
</style>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      default: false
    },
    completed: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: true
    },
    showSchedulerIndicator: {
      type: Boolean,
      default: false
    }
  }
}
</script>
